import { IconText, icons } from '../../../generic';
import styles from './UnimportedProjectRow.module.less';
import type { OnBranchChangeFn, OnSelectRepositoryFn } from './types';
import type { Repository } from '../../../../types';
import ProjectRowBase from './ProjectRowBase';

type UnimportedProjectRowProps = {
  repo: Repository;
  selectedRepos: Repository[];
  onBranchChange: OnBranchChangeFn;
  onSelectRepository: OnSelectRepositoryFn;
};

const UnimportedProjectRow = ({
  repo,
  selectedRepos,
  onBranchChange,
  onSelectRepository,
}: UnimportedProjectRowProps) => {
  const status = (
    <span className={styles.readyToImportFolder}>
      <IconText icon={icons.folderDown} text="Ready to import" marginAmount="8px" />
    </span>
  );

  return (
    <ProjectRowBase
      repo={repo}
      selectedRepos={selectedRepos}
      onBranchChange={onBranchChange}
      onSelectRepository={onSelectRepository}
      status={status}
    />
  );
};

export default UnimportedProjectRow;
